import styled from "@emotion/styled";
import { Link, ScreenReaderText, H2 } from "atoms";
import { useCollectives } from "features/collectives";

interface Props {
  artistId: string;
}

function ArtistBadges({ artistId }: Props) {
  const { data } = useCollectives({
    collectiveArtistIds: [artistId],
    perPage: 99,
  });
  const collectives = data?.pages?.flatMap((page) => page.data) ?? [];
  const badges = collectives.filter((c) => c.badge);
  return collectives.length ? (
    <Badges>
      <H2 size="md" textTransform="uppercase">
        Badges
      </H2>
      <BadgeGrid>
        {badges.map(({ id, name, badge, hasCollectivePage }) => (
          <div key={id}>
            <ScreenReaderText>{name}</ScreenReaderText>
            <Link
              to={hasCollectivePage ? `/collectives/${id}` : `/badges/${id}`}
              aria-label={`See all artists with the ${name} badge`}
            >
              <Badge src={badge.url150 ?? badge.url} alt="" />
            </Link>
          </div>
        ))}
      </BadgeGrid>
    </Badges>
  ) : null;
}

const Badges = styled.div({
  marginTop: "3rem",
});

const BadgeGrid = styled.div({
  display: "grid",
  gap: "2rem 1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  placeItems: "center start",
});

const Badge = styled.img({
  width: "100%",
  maxWidth: 140,
});

Badge.defaultProps = {
  onError: ({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) => {
    currentTarget.style.display = "none";
  },
};

export { ArtistBadges };
